<template>
    <div class="mb-5">
        <!-- TITLE -->
        <h1 class="display-heading">Search Panel Clinics</h1>

        <!-- Search -->
        <div class="mb-4">
            <div id="search-accordion">
                <div class="card">
                    <div class="card-header" id="searchTitle"  data-toggle="collapse" data-target="#searchContent" aria-expanded="true" aria-controls="searchContent">
                        <i class="fas fa-search mr-2"></i>
                        <span>Search By Optional Criteria</span>
                    </div>

                    <div id="searchContent" class="collapse" aria-labelledby="searchTitle" data-parent="#search-accordion">
                        <div class="card-body">
                            <!-- Clinic Name -->
                            <div class="row mb-2">
                                <div class="col-3">
                                    <label><b>Clinic Name</b></label>
                                </div>
                                <div class="col-9">
                                    <input type="text" class="form-control" placeholder="Enter clinic name." v-model="search.clinicName">
                                </div>
                            </div>

                            <hr>

                            <!-- Clinic Facilities -->
                            <div class="row mb-2">
                                <div class="col-3">
                                    <label><b>Facilities and Services</b></label>
                                </div>
                                <div class="col-9">
                                    <div class="row">
                                        <div class="col-lg-6 col-12" v-for="facilityAndServiceOption in facilitiesAndServicesOptions" :key="facilityAndServiceOption">
                                            <input type="checkbox" :id="facilityAndServiceOption" :value="facilityAndServiceOption" v-model="search.facilitiesAndServices">
                                            <label class="ml-2" :for="facilityAndServiceOption">{{ facilityAndServiceOption }}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr>

                            <!-- Clinic Languages -->
                            <div class="row">
                                <div class="col-3">
                                    <label><b>Spoken Languages</b></label>
                                </div>
                                <div class="col-9">
                                    <div class="row">
                                        <template v-for="language in languages">
                                            <div :key="language" class="col-12 col-lg-4">
                                                <input type="checkbox" :id="language" :value="language" v-model="search.languages">
                                                <label class="ml-2" :for="language">{{ language }}</label>
                                            </div>
                                        </template>
                                        <!-- <div class="col-12 col-1g-4">
                                            <input type="checkbox" id="english" value="English" v-model="search.languages">
                                            <label class="ml-2" for="english">English</label>
                                        </div>
                                        <div class="col-12 col-1g-4">
                                            <input type="checkbox" id="malay" value="Malay" v-model="search.languages">
                                            <label class="ml-2" for="malay">Malay</label>
                                        </div>
                                        <div class="col-12 col-1g-4">
                                            <input type="checkbox" id="chinese" value="Chinese" v-model="search.languages">
                                            <label class="ml-2" for="chinese">Chinese</label>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                            <hr>

                            <!-- Search Location -->
                            <div class="row">
                                <div class="col-3">
                                    <label><b>Search Location</b></label>
                                </div>
                                <div class="col-9">
                                    <div class="row">
                                        <div class="col-6">
                                            <input class="" type="radio" name="searchLocations" id="currentLocation" value="0" v-model="search.searchLocation">
                                            <label class="form-check-label ml-2" for="currentLocation">
                                                Current Location
                                            </label>
                                        </div>
                                        <div class="col-6">
                                            <input class="" type="radio" name="searchLocations" id="enterLocation" value="1" v-model="search.searchLocation">
                                            <label class="form-check-label ml-2" for="enterLocation">
                                                Enter Location
                                            </label>
                                        </div>

                                        <div v-show="search.searchLocation === '1'" class="col-12 mt-2">
                                            <input :id="searchBoxId" v-model="search.currentAddress" type="text" class="form-control" placeholder="Enter location name.">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr>

                            <!-- Radius -->
                            <div class="row">
                                <div class="col-3">
                                    <label><b>Distance</b></label>
                                </div>
                                <div class="col-9">
                                      <div class="form-group">
                                        <select class="form-control" v-model="search.radius">
                                            <option value="0.5">500m</option>
                                            <option value="1">1km</option>
                                            <option value="2">2km</option>
                                            <option value="5">5km</option>
                                            <option value="10">10km</option>
                                            <option value="20">20km</option>
                                            <option value="50">50km</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <!-- Search button -->
                            <div class="row mt-2">
                                <div class="col-12">
                                    <button class="btn btn-primary" @click="getNearestClinics">Search</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- List and Map -->
        <div id="list-map-wrapper" class="container">
            <div class="row">
                <div class="d-flex flex-column col-12 col-lg-3 order-lg-1 order-2 float-left border h-100 p-0">
                    <div id="list" class="flex-grow-1" :style="`height: ${resultListHeight};`">
                        <div class="m-3" v-if="isLoading">Retrieving list...</div>
                        <div v-else>
                            <div class="text-danger m-3" v-if="clinics.length <= 0">Sorry, there's no panel clinic around the search area. Expand your search area to try again.</div>
                            <div v-else>
                                <template v-for="(clinic, index) in clinics">
                                    <div :key="index">
                                        <div class="m-3">
                                            <h6> {{ ((page-1)*pageSize) + index + 1 }}. {{ clinic.name}}</h6>
                                            <div class="collapse font-sm" :id="'clinic' + index">
                                                <div>{{ clinic.address1 }}</div>
                                                <div>{{ clinic.address2 }}</div>
                                                <div>{{ clinic.postcode }}</div>
                                                <div>{{ clinic.state }}</div>
                                                <br>
                                                <div><b>Phone</b>: {{ clinic.phone }}</div>
                                                <div><b>Email</b>: {{ clinic.email }}</div>
                                                <div><b>Website</b>: {{ clinic.website ? clinic.website : '' }}</div>
                                                <br>
                                                <div><b>Spoken Languages</b>: {{ clinic.languages }}</div>
                                                <br>
                                                <div><b>Facilities and Services</b>: {{ clinic.facilities }}</div>
                                                <br>
                                                <div><b>Working Hours</b>:</div>
                                                <div class="row" v-for="(workingDay, index) in clinic.workingHours" :key="'wd' + index">
                                                    <div class="col-2">{{ getWorkingDay(workingDay.workingDayId) }}:</div>
                                                    <div class="col-9">{{ workingDay.startTime }} - {{ workingDay.endTime }}</div>
                                                </div>
                                                <br>
                                                <div><b>Working Hours Special Remarks</b>:</div>
                                                <div>
                                                {{ clinic.workingHoursSpecialRemarks ? clinic.workingHoursSpecialRemarks : '-' }}
                                                </div>

                                                <button @click="getDirection(clinic)" class="btn btn-outline-success my-3">Get Directions</button>
                                            </div>
                                            <a @click="clinic.isOpen = !clinic.isOpen" data-toggle="collapse" :href="'#' + 'clinic' + index" role="button" aria-expanded="false" :aria-controls="'clinic' + index">
                                                {{ clinic.isOpen ? "Hide Details" : "Show Details" }}
                                            </a>
                                        </div>
                                        <hr v-if="index !== clinics.length - 1">
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                    <div class="border-top p-2" v-if="!isLoading && totalPages !== 1">
                        <a @click="previousPage" v-if="page > 1" class="float-left" href="#">Previous</a>
                        <a @click="nextPage" v-if="page < totalPages" class="float-right" href="#">Next</a>
                    </div>
                </div>
                <div class="col-12 col-lg-9 order-lg-2 order-1 float-right" style="position: relative;">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        :viewBox="`0 0 1 1`"
                    >
                        <rect
                            width="1"
                            height="1"
                            x="0"
                            y="0"
                            style="
                                fill: #ffffff;
                                stroke: rgb(0, 0, 0);
                            "
                        />
                    </svg>
                    <div :id="mapId" class="google-map" style="position: absolute; top: 0; bottom: 0; left: 0; right: 0;">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* global google */
import { googleMapsConfig } from '@/config/';
import { generateRandomId } from '@/utilities/';
import facilitiesAndServicesOptions from '@/config/facilitiesAndServices';
import languages from '@/config/languages';

export default {
    data () {
        return {
            facilitiesAndServicesOptions,
            languages,
            'mapDom': '',
            'mapId': '',
            'searchBoxId': '',
            'resultListHeight': 'auto',
            'googleMapObj': '',
            'googleMapsAutoComplete': '',
            'search': {
                'clinicName': '',
                'facilitiesAndServices': [],
                'searchLocation': '0',
                'languages': [],
                'currentAddress': '',
                'radius': '10',
                'lat': null,
                'long': null
            },
            'currentLat': '',
            'currentLong': '',
            'isLoading': true,
            'clinics': [],
            'page': 1,
            'pageSize': 10,
            'totalPages': 1,
            'markers': [],
            'currentMarker': null
        };
    },
    'methods': {
        initGoogleMaps () {
            let searchBoxDOM = document.getElementById(this.searchBoxId);

            this.googleMapObj = new google.maps.Map(this.mapDOM, googleMapsConfig);
            navigator.geolocation.getCurrentPosition(this.setCurrentPositionAndGetClinics);

            // Init search box, restrict places to Malaysia only.
            this.googleMapsAutoComplete = new google.maps.places.Autocomplete(searchBoxDOM);
            this.googleMapsAutoComplete.setComponentRestrictions({ 'country': 'my' });

            this.googleMapsAutoComplete.addListener('place_changed', () => {
                let place = this.googleMapsAutoComplete.getPlace();
                let placeGeometry = place.geometry;

                this.search.currentAddress = place.name;
                if (placeGeometry) {
                    this.googleMapObj.setCenter(placeGeometry.location);
                }

                this.search.lat = place.geometry.location.lat();
                this.search.long = place.geometry.location.lng();
            });
        },
        setCurrentPositionAndGetClinics (position) {
            this.currentLat = parseFloat(position.coords.latitude);
            this.currentLong = parseFloat(position.coords.longitude);

            if (this.googleMapObj) {
                this.googleMapObj.setCenter({
                    'lat': parseFloat(position.coords.latitude),
                    'lng': parseFloat(position.coords.longitude)
                });
            };

            this.getNearestClinics();
        },
        setResultListHeight () {
            this.resultListHeight = window.innerWidth > 992 ? `${this.mapDOM.getBoundingClientRect().width}px` : 'auto';
        },
        commaFormatter (string) {
            if (!string) {
                return '';
            }

            let result = '';
            let list = string.split(',');

            for (let i = 0; i < list.length; i++) {
                if (i === list.length - 1) {
                    result += list[i];
                } else {
                    result += list[i] + ', ';
                }
            }

            return result;
        },
        getNearestClinics () {
            this.isLoading = true;

            let lat, long;

            if (this.search.searchLocation === '0') {
                lat = this.currentLat;
                long = this.currentLong;
            } else {
                lat = this.search.lat;
                long = this.search.long;
            }

            this.axios.post('Clinic/GetNearestClinics', {
                'p': this.page,
                'ps': this.pageSize,
                'cn': this.search.clinicName ? this.search.clinicName : null,
                'lt': lat,
                'lg': long,
                'fs': this.search.facilitiesAndServices,
                'sl': this.search.languages,
                'r': parseFloat(this.search.radius)
            })
                .then(({ data }) => {
                    this.isLoading = false;
                    this.totalPages = data.data.c;

                    // Remove markers
                    this.removeMarkers();
                    if (this.currentMarker) {
                        this.currentMarker.setMap(null);
                    }

                    this.clinics = data.data.l.map((clinic) => ({
                        'address1': clinic.a1,
                        'address2': clinic.a2,
                        'city': clinic.ac,
                        'postcode': clinic.ap,
                        'state': clinic.as,
                        'email': clinic.cne,
                        'phone': clinic.cnp,
                        'facilities': this.commaFormatter(clinic.fas),
                        'lat': clinic.la,
                        'long': clinic.lo,
                        'languages': this.commaFormatter(clinic.ls),
                        'name': clinic.n,
                        'website': clinic.w,
                        'workingHours': clinic.wd,
                        'workingHoursSpecialRemarks': clinic.ohsr,
                        'isOpen': false
                    }));

                    // Set markers
                    this.currentMarker = new google.maps.Marker({
                        'position': { 'lat': parseFloat(lat), 'lng': parseFloat(long) },
                        'icon': require('@/assets/img/icons/current_location.png'),
                        'map': this.googleMapObj
                    });
                    this.addMarkers();
                });
        },
        nextPage () {
            this.page++;
            this.getNearestClinics();
        },
        previousPage () {
            this.page--;
            this.getNearestClinics();
        },
        addMarkers () {
            let bounds = new google.maps.LatLngBounds();
            for (let [index, clinic] of this.clinics.entries()) {
                let position = { 'lat': parseFloat(clinic.lat), 'lng': parseFloat(clinic.long) };
                const marker = new google.maps.Marker({
                    'position': position,
                    'label': (((this.page - 1) * this.pageSize) + index + 1).toString(),
                    'map': this.googleMapObj
                });
                this.markers.push(marker);
                bounds.extend(marker.getPosition());
            }
            bounds.extend(this.currentMarker.getPosition());
            this.googleMapObj.fitBounds(bounds);
        },
        removeMarkers () {
            for (let marker of this.markers) {
                marker.setMap(null);
            }

            this.markers = [];
        },
        getDirection (clinic) {
            window.open(`https://maps.google.com/maps?daddr=${clinic.lat},${clinic.long}`);
        },
        getWorkingDay (workingDayId) {
            switch (workingDayId) {
            case 1:
                return 'Mon';
            case 2:
                return 'Tue';
            case 3:
                return 'Wed';
            case 4:
                return 'Thu';
            case 5:
                return 'Fri';
            case 6:
                return 'Sat';
            case 7:
                return 'Sun';
            }
        }
    },
    created () {
        this.mapId = generateRandomId();
        this.searchBoxId = generateRandomId();
    },
    mounted () {
        this.mapDOM = document.getElementById(this.mapId);
        this.setResultListHeight();

        window.addEventListener('resize', this.setResultListHeight);
        window.addEventListener('orientationchange', this.setResultListHeight);

        this.initGoogleMaps();
    }
};
</script>

<style scoped>
    #searchTitle {
        cursor: pointer;
    }

    #list {
        height: inherit;
    }

    @media (min-width: 1024px) {
        #list{
            overflow: auto;
        }
    }
</style>
